import * as React from 'react';
import { Link } from 'react-router-dom';
import { MeatballMenu } from 'ui';
import { routeConstants } from 'app/routes/route-constants';
import { PersonActionType } from 'app/area/administration/shared/types';
import { ids } from 'app/area/administration/constants';

import styles from './role-toolbar.scss';

interface ToolbarProps {
  totalResultHits?: number;
  exportExcelFetching?: boolean;
  translation: any;
  canCreate: boolean;
  canRead: boolean;
  onExportToExcel?: () => void;
}

export const RoleToolbar: React.FC<ToolbarProps> = props => {
  const { totalResultHits, onExportToExcel, exportExcelFetching, canCreate, canRead, translation } = props;

  if (!canCreate && !canRead) {
    return null;
  }

  const isExportDisabled = exportExcelFetching || totalResultHits === 0 || totalResultHits === undefined;

  return <>
    {canCreate && <Link id={ids.roles.add_button} to={routeConstants.roleAddFor(PersonActionType.add)} className="btn btn-primary" >
      {props.translation.new_role}
    </Link>}
    {canRead
      && <div className={styles.meatball}>
        <MeatballMenu closeAfterClick={true}>
          <li className={`${isExportDisabled ? styles.notAllowed : ''}`}>
            <button className="dropdown-item"
              id={ids.roles.export_excel}
              onClick={onExportToExcel}
              disabled={isExportDisabled}>
              {translation.excel_export_item_text}
            </button>
          </li>
        </MeatballMenu>
      </div>}
  </>;
};
